module.exports = __webpack_public_path__ + "img/1F4A1.7c521206.svg";